// grace window for in-flight requests with the old token to await silent re-login
const TAIL_CLOSE_MS = 2000;

let inFlight: Promise<void> | null = null;
let resolveInFlight: (() => void) | null = null;
let activeCount = 0;
let inTailWindow = false;
let tailCloseTimer: ReturnType<typeof setTimeout> | null = null;

const clearTailTimer = (): void => {
  if (tailCloseTimer) {
    clearTimeout(tailCloseTimer);
    tailCloseTimer = null;
  }
};

export const beginSelfChange = (): void => {
  clearTailTimer();
  inTailWindow = false;
  activeCount += 1;
  if (inFlight) return;
  inFlight = new Promise<void>((resolve) => {
    resolveInFlight = resolve;
  });
};

export const endSelfChange = (): void => {
  if (activeCount > 0) activeCount -= 1;
  if (activeCount > 0) return;
  resolveInFlight?.();
  inFlight = null;
  resolveInFlight = null;
  inTailWindow = true;
  clearTailTimer();
  tailCloseTimer = setTimeout(() => {
    tailCloseTimer = null;
    inTailWindow = false;
  }, TAIL_CLOSE_MS);
};

export const isSelfChangeInFlight = (): boolean => inFlight !== null || inTailWindow;

export const waitForSelfChange = (): Promise<void> => inFlight ?? Promise.resolve();
